<template>
  <div class="ExhibitionPage">
    <h1 class="Header">&bull;UTSTÄLLNINGAR&bull;</h1>
    <div class="Content">
      <Editor textId="ExhibitionPage"/>
    </div>
  </div>
</template>

<script>
import Editor from '@/Components/Editor';

export default {
  components: {
    Editor,
  },
};
</script>

<style scoped>
.Content {
  margin: 0 20vw;
}

.ExhibitionPage {
  padding-bottom: 40px;
}

.Header {
  letter-spacing: 20px;
}

.previousEvents {
  margin-top: 100px;
}

table {
  font-weight: 300;
  border-collapse: collapse;
  width: 100%;
  background-color: rgb(22, 22, 22);
  color: beige;
}

td,
th {
  border: 1px solid rgb(80, 80, 80);
  text-align: left;
  padding: 8px;
}

th {
  background-color: black;
}

tr:nth-child(even) {
  background-color: black;
}
</style>
